import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=329738f6"
import script from "./AdminReports.vue?vue&type=script&lang=ts"
export * from "./AdminReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports